import React from 'react';
import styled from 'styled-components';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { ToggleButton } from 'primereact/togglebutton';
import { InfoTooltip } from "ui-kit/Tooltip/InfoTooltip";
import { Typography } from "../Typography";

interface FormToggleProps extends FieldProps<boolean, FieldRenderProps<boolean>> {}

export const FormToggle: React.FC<FormToggleProps> = props => {
  return (
    <Field
      type="checkbox"
      render={({ input }) => (
        <Container id={props.id}>
          <StyledToggleButton
            checked={input.checked}
            onChange={(e) => input.onChange(e.value )}
          />
          <Label>
            <Typography variant="body6">
              <label htmlFor={props.name}>{props.label}</label>
            </Typography>
            {props.tooltip && <InfoTooltip name={`select-tooltip-${props.name}`} tooltip={props.tooltip} />}
          </Label>
        </Container>
      )}
      {...props}
    />
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const StyledToggleButton = styled(ToggleButton)<{ checked?: boolean }>`
  width: 50px;
  height: 30px;
  border-radius: 15px;
  background-color: ${({ checked, theme }) => checked ? theme.palette.button.primary : '#ccc'};
  position: relative;
  transition: background-color 0.3s, transform 0.3s;
  border: none;

  .p-button {
    display: none;
  }

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: ${({ checked }) => checked ? '23px' : '3px'};
    width: 24px;
    height: 24px;
    background-color: white;
    border-radius: 50%;
    transition: left 0.3s;
  }
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
